import type { PinItemType } from './Pinned';

export type ISidebarRowBase = {
  portfolioTreeId: string;

  /**
   * The depth at which the row is.
   *
   * Master portfolio = 0
   * First children = 1
   * Children of the first children = 2
   * etc,
   */
  depth: number;
};

export type ISidebarRowStrategy = ISidebarRowBase & {
  code?: string;
  type?: PinItemType;
};

export type ISidebarRowSubportfolio = ISidebarRowBase & {
  children: ISidebarRow[];
  isExpanded: boolean;
};

export type ISidebarRow = ISidebarRowStrategy | ISidebarRowSubportfolio;

export const isISidebarRowSubportfolio = (row: ISidebarRow): row is ISidebarRowSubportfolio =>
  (row as ISidebarRowSubportfolio).children !== undefined;
